import { i18n } from '../plugins/i18n'

/**
 * TODO: カスタムアンケートのフォームとこのロジックを統合したい
 * @param label { string } i18nのキー
 * @param max { number } 文字列の最大値
 * @param currentLength { number } 現在の文字列の長さ。maxを指定するなら必要
 * @param required { boolean } 必須のラベルをつけるかどうか
 * @return string
 */
const formatLabelText = ({ label, max, currentLength, required = true }) => {
  if (label == null) throw new Error('Set label.')
  if (max != null && currentLength == null) throw new Error('If you wanna set max, you need to set currentLength.')

  let text = i18n.t(label)
  if (max != null) {
    text += i18n.t('labels.labelCount', { current: currentLength , max: max })
  }
  text += required ? i18n.t('labels.requiredLabel') : i18n.t('labels.optionalLabel')
  return text
}

export default formatLabelText
